
const data = [
  {
    id: "home",
    icon: "home",
    caption: "Home",
    to: "/dashboard",
    title: "Firm Dashboard",
    description: " Firm facing dashboard and control center",
    display: [],
    permissions: ["CAN.LOGIN"],
    contains: {
      indent: 0,
      items: [
        {
          id: "my_profile",
          icon: "presentation",
          caption: "My Profile",
          to: "/dashboard/profile",
          title: "My Profile",
          description: "Biographical information about you",
          display: ["Sidebar"],
          permissions: ["CAN.LOGIN"],
        },
        {
          id: "firm_people",
          icon: "user",
          caption: "People",
          to: "/dashboard/people",
          title: "People",
          description: "People Information",
          display: ["Sidebar", "Mobile"],
          permissions: ["VIEW.PERSON"],
          contains: {
            indent: 1,
            hide: true,
            items:
              [
                {
                  id: "add_person",
                  icon: "content",
                  caption: "This Person",
                  to: "/dashboard/people/add",
                  title: "New person",
                  display: [],
                  permissions: ["VIEW.PERSON"],
                },
                {
                  id: "edit_person",
                  icon: "content",
                  caption: "This Person",
                  to: "/dashboard/people/:id",
                  title: "Edit person",
                  display: [],
                  permissions: ["VIEW.PERSON"],
                },
                
              ]
          }
        },
        {
          id: "firm_companies",
          icon: "building-large",
          caption: "Companies",
          to: "/dashboard/companies",
          title: "Companies",
          description: "Company Information",
          display: ["Sidebar", "Mobile"],
          permissions: ["VIEW.PERSON"],
          contains: {
            indent: 1,
            hide: true,
            items:
              [
                {
                  id: "add_company",
                  icon: "content",
                  caption: "This Company",
                  to: "/dashboard/companies/add",
                  title: "New company",
                  display: [],
                  permissions: ["VIEW.PERSON"],
                },
                {
                  id: "edit_company",
                  icon: "content",
                  caption: "This Company",
                  to: "/dashboard/companies/:id",
                  title: "Edit company",
                  display: [],
                  permissions: ["VIEW.PERSON"],
                },
              ]
          }
        },
        {
          id: "firm_leads",
          icon: "presentation",
          caption: "Leads",
          to: "/dashboard/leads",
          title: "Leads",
          description: "Lead follow-up queue",
          display: ["Sidebar", "Mobile"],
          permissions: ["VIEW.PERSON"],
        },
        {
          id: "signature_envelope",
          icon: "pen",
          caption: "Signature Request",
          to: "/dashboard/signatures/new",
          title: "Signature Request",
          description: "Prepare and send a signature envelope",
          display: [],
          permissions: ["VIEW.SIGNATURE"],
        },
        {
          id: "firm_matters",
          icon: "archive",
          caption: "Matters",
          to: "/dashboard/matters",
          title: "Matters",
          description: "Matter Information",
          display: ["Sidebar", "Mobile"],
          permissions: ["VIEW.MATTER"],
          contains: {
            indent: 1,
            hide: true,
            items:
              [
                {
                  id: "add_matter",
                  icon: "content",
                  caption: "This Matter",
                  to: "/dashboard/matters/add",
                  title: "New matter",
                  display: [],
                  permissions: ["VIEW.MATTER"],
                },
                {
                  id: "edit_matter",
                  icon: "content",
                  caption: "This Matter",
                  to: "/dashboard/matters/:id",
                  title: "Edit matter",
                  display: [],
                  permissions: ["VIEW.MATTER"],
                }
              ]
          }
        },
        
        {
          id: "view_courts",
          icon: "building-large",
          caption: "Courts",
          to: "/dashboard/courts",
          title: "Courts",
          display: ["Sidebar"],
          permissions: ["VIEW.COURT"],
          contains: {
            indent: 1,    
            hide: true,
            items:
              [
                {
                  id: "view_court",
                  icon: "building-large",
                  caption: "Court",
                  to: "/dashboard/courts/:id",
                  title: "Court",
                  display: [],
                  permissions: ["VIEW.COURT"],
                },
              ]
          }
        },
        {
          id: "view_accounting",
          icon: "money",
          caption: "Accounting",
          to: "/dashboard/accounting",
          title: "Accounting",
          display: ["Sidebar"],
          permissions: ["VIEW.PAYROLL", "VIEW.SETTINGS"],
          contains: {
            indent: 1,    
            hide: false,
            items:
              [
                {
                  id: "view_accounting_ledger",
                  icon: "dollar",
                  caption: "Ledger",
                  to: "/dashboard/accounting/ledger",
                  title: "Ledger",
                  description: "Accounts Ledger",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                },
                {
                  id: "view_accounting_check_register",
                  icon: "print",
                  caption: "Check Register",
                  to: "/dashboard/accounting/checks/register",
                  title: "Check Register",
                  description: "Accounting Check Register",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                },
                {
                  id: "view_accounting_reconciliations",
                  icon: "check-square",
                  caption: "Reconciliation",
                  to: "/dashboard/accounting/reconciliations",
                  title: "Bank Reconciliation",
                  description: "Bank Reconciliation",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                  contains: {
                    indent: 1,
                    hide: true,
                    items: [
                      {
                        id: "view_accounting_reconciliation",
                        icon: "check-square",
                        caption: "Reconciliation",
                        to: "/dashboard/accounting/reconciliations/:id",
                        title: "Bank Reconciliation",
                        display: [],
                        permissions: ["VIEW.SETTINGS"],
                      },
                    ],
                  },
                },
                {
                  id: "view_accounting_accounts",
                  icon: "money",
                  caption: "Accounts",
                  to: "/dashboard/accounting/accounts",
                  title: "Accounts",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                  contains: {
                    indent: 1,
                    hide: true,
                    items:
                      [
                        {
                          id: "view_accounting_account",
                          icon: "tag",
                          caption: "Account",
                          to: "/dashboard/accounting/accounts/:id",
                          title: "Account",
                          display: [],
                          permissions: ["VIEW.SETTINGS"],
                        },
                      ]
                  }
                },
                {
                  id: "view_accounting_financial_accounts",
                  icon: "money",
                  caption: "Financial Accounts",
                  to: "/dashboard/accounting/financial-accounts",
                  title: "Financial Accounts",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                  contains: {
                    indent: 1,
                    hide: true,
                    items:
                      [
                        {
                          id: "view_accounting_financial_account",
                          icon: "tag",
                          caption: "Financial Account",
                          to: "/dashboard/accounting/financial-accounts/:id",
                          title: "Financial Account",
                          display: [],
                          permissions: ["VIEW.SETTINGS"],
                        },
                      ]
                  }
                },
                {
                  id: "view_acct_payroll",
                  icon: "money",
                  caption: "Payrolls",
                  to: "/dashboard/accounting/payroll",
                  title: "Payrolls",
                  display: ["Sidebar"],
                  permissions: ["VIEW.PAYROLL"],
                  contains: {
                    indent: 1,    
                    hide: true,
                    items:
                      [
                        {
                          id: "view_payroll_item",
                          icon: "tag",
                          caption: "Payroll",
                          to: "/dashboard/accounting/payroll/:id",
                          title: "Payroll Check",
                          display: ["Sidebar"],
                          permissions: ["VIEW.PAYROLL"],
                        },
                      ]
                  }
                },
                
                {
                  id: "view_payperiod_settings",
                  icon: "tag",
                  caption: "Pay Periods",
                  to: "/dashboard/accounting/payperiods",
                  title: "Pay Periods",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                  contains: {
                    indent: 1,    
                    hide: true,
                    items:
                      [
                        {
                          id: "view_payperiod_setting",
                          icon: "tag",
                          caption: "Pay Period",
                          to: "/dashboard/accounting/payperiods/:id",
                          title: "Pay Period",
                          display: [],
                          permissions: ["VIEW.SETTINGS"],
                        },
                      ]
                  }
                },          
                
                {
                  id: "view_payschedule_settings",
                  icon: "tag",
                  caption: "Pay Schedules",
                  to: "/dashboard/accounting/payschedules",
                  title: "Pay Schedules",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                  contains: {
                    indent: 1,    
                    hide: true,
                    items:
                      [
                        {
                          id: "view_payschedule_setting",
                          icon: "tag",
                          caption: "Pay Schedule",
                          to: "/dashboard/accounting/payschedules/:id",
                          title: "Pay Schedule",
                          display: [],
                          permissions: ["VIEW.SETTINGS"],
                        },
                      ]
                  }
                },
              ]
          }
        },
        {
          id: "firm_clients",
          icon: "folder",
          caption: "Clients",
          to: "/dashboard/clients",
          title: "Clients",
          description: "Client information",
          display: ["Sidebar", "Mobile"],
          permissions: ["VIEW.CLIENTS"],
          contains: {
            indent: 1,
            hide: true,
            items:
              [
                {
                  id: "add_client",
                  icon: "content",
                  caption: "This Client",
                  to: "/dashboard/clients/add",
                  title: "New client",
                  display: [],
                  permissions: ["MODIFY.CLIENT"],
                },
                {
                  id: "edit_client",
                  icon: "content",
                  caption: "This Client",
                  to: "/dashboard/clients/:id",
                  title: "Edit client",
                  display: [],
                  permissions: ["MODIFY.CLIENT"],
                }
              ]
          }
        },
        {
          id: "reports",
          icon: "file-chart",
          caption: "Reports",
          to: "/dashboard/reports",
          title: "Reports",
          description: "Report template",
          display: ["Sidebar"],
          permissions: ["VIEW.REPORTS"],
          contains: {
            indent: 1,
            hide: true,
            items:
              [
                {
                  id: "add_report",
                  icon: "content",
                  caption: "This Report",
                  to: "/dashboard/reports/add",
                  title: "New report",
                  display: [],
                  permissions: ["VIEW.REPORTS"],
                },
                {
                  id: "edit_report",
                  icon: "content",
                  caption: "This Report",
                  to: "/dashboard/reports/:id",
                  title: "Edit report",
                  display: [],
                  permissions: ["VIEW.REPORTS"],
                }
              ]
          }
        },
        {
          id: "ledger",
          icon: "dollar",
          caption: "Ledger",
          to: "/dashboard/ledger",
          title: "Ledger",
          description: "Accounts Ledger",
          display: ["Sidebar"],
          permissions: ["VIEW.LEDGER"]
        },
        {
          id: "administration",
          icon: "gear",
          caption: "Settings",
          to: "/dashboard/settings",
          title: "Settings",
          description: "Settings items",
          display: ["Sidebar"],
          permissions: ["VIEW.SETTINGS","MANAGE.FIRM"],
          contains: {
            indent: 1,
            items:
              [
                {
                  id: "view_accounting_settings",
                  icon: "dollar",
                  caption: "Accounting",
                  to: "/dashboard/settings/accounting",
                  title: "Accounting",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                },
                {
                  id: "view_calendars",
                  icon: "calendar",
                  caption: "Calendars",
                  to: "/dashboard/settings/calendars",
                  title: "Calendars",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                  contains: {
                    indent: 1,    
                    hide: true,
                    items:
                      [
                        {
                          id: "view_calendar",
                          icon: "calendar",
                          caption: "Calendar",
                          to: "/dashboard/settings/calendars/:id",
                          title: "Calendar",
                          display: [],
                          permissions: ["VIEW.SETTINGS"],
                        },
                      ]
                  }
                },
                {
                  id: "view_email_settings",
                  icon: "email",
                  caption: "Profiles",
                  to: "/dashboard/settings/email",
                  title: "Email",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                  contains: {
                    indent: 1,    
                    hide: true,
                    items:
                      [
                        {
                          id: "view_email_settings",
                          icon: "email",
                          caption: "Email Send Settings",
                          to: "/dashboard/settings/email/:id",
                          title: "Email",
                          display: [],
                          permissions: ["VIEW.SETTINGS"],
                        },
                      ]
                  }
                },
                {
                  id: "view_event_settings",
                  icon: "notification",
                  caption: "Events",
                  to: "/dashboard/settings/events",
                  title: "Events",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                },
                {
                  id: "view_hook_settings",
                  icon: "link",
                  caption: "Hooks",
                  to: "/dashboard/settings/hooks",
                  title: "Hooks",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                },
                {
                  id: "view_lead_settings",
                  icon: "presentation",
                  caption: "Leads",
                  to: "/dashboard/settings/leads",
                  title: "Leads",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                },
                {
                  id: "view_lead_workflow_settings",
                  icon: "presentation",
                  caption: "Lead Workflow",
                  to: "/dashboard/settings/lead-workflow",
                  title: "Lead Workflow",
                  description: "Lead workflow and campaigns",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                },
                {
                  id: "view_board_settings",
                  icon: "board-1",
                  caption: "Boards",
                  to: "/dashboard/settings/boards",
                  title: "Boards",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                },
                {
                  id: "view_expense_settings",
                  icon: "tag",
                  caption: "Expenses",
                  to: "/dashboard/settings/expenses",
                  title: "Expenses",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                  contains: {
                    indent: 1,    
                    hide: true,
                    items:
                      [
                        {
                          id: "view_expense_setting",
                          icon: "tag",
                          caption: "Expense Configuration",
                          to: "/dashboard/settings/expenses/:id",
                          title: "Expense",
                          display: [],
                          permissions: ["VIEW.SETTINGS"],
                        },
                      ]
                  }
                },
                {
                  id: "view_firm_settings",
                  icon: "building",
                  caption: "Firm Information",
                  to: "/dashboard/settings/firm",
                  title: "Firm",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS","MANAGE.FIRM"],
                },
                {
                  id: "view_rate_settings",
                  icon: "tag",
                  caption: "Rates",
                  to: "/dashboard/settings/rates",
                  title: "Rates",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                  contains: {
                    indent: 1,    
                    hide: true,
                    items:
                      [
                        {
                          id: "view_rate_setting",
                          icon: "tag",
                          caption: "Rate Tiers",
                          to: "/dashboard/settings/rates/:id",
                          title: "Rate",
                          display: [],
                          permissions: ["VIEW.SETTINGS"],
                        },
                      ]
                  }
                },
                {
                  id: "view_role_settings",
                  icon: "tag",
                  caption: "Roles",
                  to: "/dashboard/settings/roles",
                  title: "Roles",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                  contains: {
                    indent: 1,    
                    hide: true,
                    items:
                      [
                        {
                          id: "view_role_setting",
                          icon: "tag",
                          caption: "Role",
                          to: "/dashboard/settings/roles/:id",
                          title: "Role",
                          display: [],
                          permissions: ["VIEW.SETTINGS"],
                        },
                      ]
                  }
                },
                {
                  id: "view_survey_settings",
                  icon: "clipboard",
                  caption: "Surveys",
                  to: "/dashboard/settings/surveys",
                  title: "Surveys",
                  display: ["Sidebar"],
                  permissions: ["EDIT.SURVEY"],
                  contains: {
                    indent: 1,    
                    hide: true,
                    items:
                      [
                        {
                          id: "survey_builder",
                          icon: "duplicate",
                          caption: "Builder",
                          to: "/dashboard/settings/surveys/editor",
                          title: "Survey Builder",
                          display: [],
                          permissions: ["EDIT.SURVEY"],
                        },
                        {
                          id: "survey_builder_item",
                          icon: "duplicate",
                          caption: "Builder",
                          to: "/dashboard/settings/surveys/editor/:id",
                          title: "Survey Builder",
                          display: [],
                          permissions: ["EDIT.SURVEY"],
                        },
                        {
                          id: "view_survey_settings",
                          icon: "content",
                          caption: "Survey",
                          to: "/dashboard/settings/surveys/:id",
                          title: "Survey Configuration",
                          display: [],
                          permissions: ["EDIT.SURVEY"],
                        }
                      ]
                  }
                },
                {
                  id: "view_templates",
                  icon: "content",
                  caption: "Templates",
                  to: "/dashboard/templates",
                  title: "Templates",
                  display: ["Sidebar"],
                  permissions: ["VIEW.SETTINGS"],
                  contains: {
                    indent: 1,    
                    hide: true,
                    items: [
                      {
                        id: "view_email_template",
                        icon: "content",
                        caption: "Email Template",
                        to: "/dashboard/templates/email/:id",
                        title: "Email Template",
                        display: [],
                        hide: true,
                        permissions: ["VIEW.SETTINGS"],
                      },
                      {
                        id: "view_report_template",
                        icon: "content",
                        caption: "Report Template",
                        to: "/dashboard/templates/report/:id",
                        title: "Report Template",
                        display: [],
                        hide: true,
                        permissions: ["VIEW.SETTINGS"],
                      },
                      
                    ],
                    
                  }
                },
                {
                  id: "view_users",
                  icon: "user",
                  caption: "Users",
                  to: "/dashboard/users",
                  title: "Users",
                  display: ["Sidebar"],
                  permissions: ["VIEW.USER"],
                  contains: {
                    indent: 1,    
                    hide: true,
                    items:
                      [
                        {
                          id: "view_users",
                          icon: "user",
                          caption: "User",
                          to: "/dashboard/users/:id",
                          title: "Users",
                          display: [],
                          permissions: ["VIEW.USER"],
                        },
                      ]
                  }
                },
              ]
          }
        },
      ]
    }
  }
];

export default data;

